import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {houseBillList} from '../tableSettings';
import {Search} from "../../../filtering";
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import {JobNames} from '../../../framework.core/JobNames';
import * as XCol from '../../../framework.core/XExportColumn';
import IfmsModal from '../../../ui/IfmsModal';
import ViewMbl from './implementation/ViewMbl';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { DocumentType } from '../../../framework.core/DocumentType';
import ApplicationContext from '../../../ApplicationContext';
import { ListFilterType } from '../../../fms.core/constants';
import { AciManifestListItem } from '../../../fms.data/models/AciManifestListItem';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { useHistory } from 'react-router';
import { AmsHouseListItem } from '../../../fms.data/models/AmsHouseListItem';
import useReportViewer from '../../../hooks/useReportViewer';
import { AciHistoryArgs } from '../../../fms.report/args';

import IconButton, { ViewHistoryIconButton } from '../../../ui/IconButton';
import BlockIcon2 from '../../../img/Block2.svg';
import BlockIcon2_D from '../../../img/Block_Dark.svg';
import CBlockIcon2 from '../../../img/Cancel Block2.svg';
import CBlockIcon2_D from '../../../img/Cancel Block_Dark.svg';
import DownIcon2 from '../../../img/AMS - Download to OI2.svg';
import DownIcon2_D from '../../../img/AMS - Download to OI_Dark2.svg';
import mblAll2 from '../../../img/AMS - List All2.svg';
import mblAll2_D from '../../../img/AMS - List All_Dark2.svg';
import mblNotDown2 from '../../../img/AMS - download-not2.svg';
import mblNotDown2_D from '../../../img/AMS - download-not_Dark2.svg';
import mblDown2 from '../../../img/AMS - downloaded2.svg';
import mblDown2_D from '../../../img/AMS - downloaded_Dark2.svg';

function useHblOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToHblFor(hbl:AmsHouseListItem|null) {
    if (!hbl) {
      return;
    }
    jobListContext.setFilterForScreenExternally('/common/joblistview/hbl/oceanImport', 
      'hblNo', 'HBL', hbl.hblNo, 'u2Date', false, true,null, null, null, false, true);
    openNewPage(history, `/common/joblistview/hbl/oceanImport`, NavigationType.newPage);
  }

  function switchToMblFor(hbl:AmsHouseListItem|null) {
    if (!hbl) {
      return;
    }
    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSM/oceanImport', 
    'mblNo', 'MBL #', hbl.mblNo, '', false, true, null, null, null, false, true);
    openNewPage(history, `/common/joblistview/AMSM/oceanImport`, NavigationType.newPage);
  }

  return { switchToHblFor, switchToMblFor };
}

function useSelectedHblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const { switchToHblFor, switchToMblFor } = useHblOperations();

  const selectedElement = jobListContext.selectedElement as AmsHouseListItem|null;

  function switchToAmsHbl() {
    const selectedElement = jobListContext.selectedElement as AmsHouseListItem;
    switchToHblFor(selectedElement);
  }

  function switchToAmsMbl() {
    const selectedElement = jobListContext.selectedElement as AmsHouseListItem;
    switchToMblFor(selectedElement);
  }

  return { selectedElement, switchToAmsHbl, switchToAmsMbl };
}
function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const jobListContext = useContext(JobListViewContext);

  const items = [
    { label: 'Go to MBL List', shortcut: 'Shift+F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to HBL List', shortcut: 'F6', separator: false },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
      //  switchToAmsMbl();
        break;
      case 1:
        jobListContext.triggerTableSearch('F5');
        break;
      case 2:
        //switchToAmsHbl();
        break;
      case 3:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ViListCommands() {
  const {viewReport} = useReportViewer(); 
  const { selectedElement } = useSelectedHblOperations();
  const [ showGlobalYesNoDialog ] = useGlobalYesNoDialog();
  const [view, showView] = useState(false);
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listFilter = jobListContext.listFilter || 'A';
  const history = useHistory();

  async function block(isBlock: boolean) {
    const doBlock = await showGlobalYesNoDialog(<p style={{ fontWeight: 'bold', fontSize: '13px' }}>Are you sure you want to {(isBlock ? "Block" : "Cancel block")}?</p>,false, 0, true)

    if (doBlock) {
      const id = selectedElement?.id;

      await appContext.api.block(JobNames.ACIManifest, id, isBlock);

      jobListContext.reloadData();
    } else {
      return;
    }
  }
  function dismissView() {
    showView(false);
    jobListContext.dismissPopupRow();
  }

  async function changeListData(type: string) {
    jobListContext.setListFilter?.(type);
    const listFilterType = type === 'A' ? ListFilterType.All : (type === 'D' ? ListFilterType.Downloaded : ListFilterType.Virgin);

    jobListContext.changeListData?.(
      JobNames.ACIManifest,
      'AciManifestListItem',
      AciManifestListItem.calculateSearchParameters(jobListContext.search, AciManifestListItem.MapSearchFields),
      'AMS',
      listFilterType,
      AciManifestListItem.formatData 
    );
  }

  async function openHistoryReport() {
    if (!selectedElement?.id) return;

    const title = "ACI House Bill CCN # " + selectedElement?.houseBill;
    const args = new AciHistoryArgs({
      docType: DocumentType.AciHistory,
      formCaption: title,
      subject: title,

      houseID: Number(selectedElement?.id),
    })
    viewReport(args, "", true);
  }

  async function viewDownloadView() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/download/${JobNames.ACIManifest}/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return (
    <div className='ifms-common-no-vertical-separator'>
      <IconButton
        disabled={!selectedElement}
        onClick={() => block(true)}
        data-tooltip='Block' icon={appContext.useDarkMode ? BlockIcon2_D : BlockIcon2}
      >
      </IconButton>
      <IconButton
        disabled={!selectedElement}
        onClick={() => block(false)}
        data-tooltip='Cancel Block' icon={appContext.useDarkMode ? CBlockIcon2_D : CBlockIcon2}
      >
      </IconButton>
      <IconButton
        disabled={!selectedElement}
        onClick={() => viewDownloadView()}
        data-tooltip='Download to OI' icon={appContext.useDarkMode ? DownIcon2_D : DownIcon2}
      >
      </IconButton>
      <ViewHistoryIconButton
        disabled={!selectedElement}
        onClick={() => openHistoryReport()}/>
      <IconButton
        size='imgStyle'
        data-tooltip="All"
        disabled={listFilter === 'A'}
        onClick={async () => {
          changeListData('A')
        }}
        icon = {appContext.useDarkMode ? mblAll2_D : mblAll2}>
      </IconButton>
      <IconButton
        size='imgStyle'
        data-tooltip="Downloaded"
        disabled={listFilter === 'D'}
        onClick={async () => {
          changeListData('D')
        }}
        icon = {appContext.useDarkMode ? mblDown2_D : mblDown2}>
      </IconButton>
      <IconButton
        size='imgStyle'
        data-tooltip="Ready to Download"
        disabled={listFilter === 'N'}
        onClick={async () => {
          changeListData('N')
        }}
        icon = {appContext.useDarkMode ? mblNotDown2_D : mblNotDown2}>
      </IconButton>
      <IfmsModal isBlueHeader onCancel={dismissView} draggable isOpen={view || !!jobListContext.viewPopupRow} title="View MBL" width="760px">
        <ViewMbl onPopupClose={dismissView} selectedElementId={selectedElement?.id ?? ''} />
      </IfmsModal>
    </div>
  );
}

function ViListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ViListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});
  const { switchToAmsMbl, switchToAmsHbl } = useSelectedHblOperations();
  const jobListContext = useContext(JobListViewContext);
  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );


  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToAmsMbl();
    } else if (unprocessedFkey === "SHIFT+F4") {
      switchToAmsHbl();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }


  function onFunctionKey(fkey:string) {
    if (['F4', 'SHIFT+F4', 'F6', 'F8', 'F9', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return null;
}

/**
 * Concrete implementation for AMS MBL List screen
 *
 * @class HouseBillListView
 * @extends {AbstractListView}
 */
class HouseBillListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.ACIManifest,
      'AciManifestListItem',
      AciManifestListItem.calculateSearchParameters(search, AciManifestListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      'ACI');

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: AciManifestListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  
  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.ACIManifest, 'AciManifestListItem',
    AciManifestListItem.calculateSearchParameters(search, AciManifestListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
      'ACI'
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  AciManifestListItem.formatData(apiResult.entities);
  }


  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return AciManifestListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = houseBillList;
    const cols = AciManifestListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    
    return tsettings;
  }

  renderCommands() {
    return (
      <ViListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ViListToolbar />
    );
  }


  renderExtras() {
    return <ViListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  hasViewPopup(): boolean {
    return false;
  }

  getListViewTitle() {
    return `ACI eManifest House Bill`;
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
};

export default HouseBillListView;
